import React from 'react'
import PropTypes from 'prop-types'
import CourseComponent from 'components/CourseComponent'
import LearnErrorBoundary from 'components/LearnErrorBoundary'
import UnitComponent from 'components/UnitComponent'
import { HeadingSpacer } from './component.styles'
import { UnitType } from 'components/UnitComponent/types'
import {
  lessonsAmountsType,
  scopeAndSequenceLinksType,
} from 'experienceComponents/CourseHeader'
import { isFlagOn } from 'utils/featureFlags'
import { isElementaryPage } from 'utils/productHelpers'

export const Component = props => {
  const {
    acknowledgements,
    displayTitle,
    match,
    onSelectUnit,
    productName,
    scopeAndSequenceData,
    lessonsAmounts,
    unitId,
    unit,
  } = props
  if (
    isElementaryPage() &&
    isFlagOn(['feature_LEARN-20164-k5-site-selection'])
  ) {
    console.log('[DEBUG] CoursePreview rendering K5 in program flex')
  }

  return (
    <LearnErrorBoundary>
      <HeadingSpacer />
      <CourseComponent
        displayTitle={displayTitle}
        isActive={false}
        isEditable={false}
        lessonsAmounts={lessonsAmounts}
        scopeAndSequenceLinks={scopeAndSequenceData}
        title={displayTitle}
      >
        <UnitComponent
          acknowledgements={acknowledgements}
          match={match}
          onSelectUnit={onSelectUnit}
          productName={productName}
          unit={unit}
          unitId={unitId}
        />
      </CourseComponent>
    </LearnErrorBoundary>
  )
}

Component.propTypes = {
  acknowledgements: PropTypes.shape({
    contentType: PropTypes.string,
    description: PropTypes.string,
    displayTitle: PropTypes.string,
    id: PropTypes.string,
    internalTitle: PropTypes.string,
    locale: PropTypes.string,
    pageData: PropTypes.string,
    type: PropTypes.string,
  }),
  displayTitle: PropTypes.string.isRequired,
  lessonsAmounts: lessonsAmountsType,
  match: PropTypes.object.isRequired,
  onSelectUnit: PropTypes.func.isRequired,
  productName: PropTypes.string,
  scopeAndSequenceData: scopeAndSequenceLinksType,
  unit: UnitType.isRequired,
  unitId: PropTypes.string.isRequired,
}

export default Component
